import { render, staticRenderFns } from "./IdentityVerificationHeader.vue?vue&type=template&id=117d5b60&scoped=true"
import script from "./IdentityVerificationHeader.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationHeader.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerificationHeader.vue?vue&type=style&index=0&id=117d5b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117d5b60",
  null
  
)

export default component.exports